export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s nie zostały wybrane';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s nie może być puste';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s to pole obowiązkowe';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s nie zostało poprawnie wypełnione';
                break;

            case 'opt-in':
                translation = 'Proszę zaznaczyć zgodę, aby kontynuować';
                break;

            default:
                translation = 'To pole nie zostało wypełnone poprawnie';
                break;
        }

        return translation;
    }
}
